import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/Bits";
import { datetime } from "@/lib/format";
import { ScrollText } from "lucide-react";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)); }, []);
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <PageHeader title="Audit Trail" subtitle="Every correction and key change, with who and when" />
      {rows.length === 0 ? <Empty text="No audit records yet." /> : (
        <div className="card-industrial divide-y divide-border">
          {rows.map((a) => (
            <div key={a.id} className="px-4 py-3 flex items-start gap-3" data-testid={`audit-${a.id}`}>
              <ScrollText className="w-4 h-4 text-muted-foreground mt-0.5 shrink-0" />
              <div className="flex-1">
                <div className="text-sm">
                  <span className="font-semibold">{a.user_name || "System"}</span>
                  <span className="text-muted-foreground"> {a.action} </span>
                  <span className="font-mono text-xs px-1.5 py-0.5 rounded bg-accent">{a.entity_type}</span>
                  {a.note && <span className="text-muted-foreground"> — {a.note}</span>}
                </div>
                {(a.before || a.after) && (
                  <div className="text-[11px] font-mono text-muted-foreground mt-1">
                    {a.before && <span className="text-red-400/70">was: {JSON.stringify(a.before)} </span>}
                    {a.after && <span className="text-emerald-400/70">→ {JSON.stringify(a.after)}</span>}
                  </div>
                )}
              </div>
              <span className="text-[11px] text-muted-foreground font-mono whitespace-nowrap">{datetime(a.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
